import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=74908ef0"
import script from "./Stock.vue?vue&type=script&lang=ts"
export * from "./Stock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports